import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'lucide-react';
import apiService from '../services/apiService';

interface OilSelectionProps {
  carDetails: {
    brand: string;
    model: string;
    engine: string;
    id_brand : number;
  };
  onNextStep: (oilDetails: { brand: string  },pricing : PricingDetails | undefined) => void;
  onBackStep: () => void;
}
interface PricingDetails {
  oil_price: { [key: string]: number };
  oil_filter_price: number;
  oil_capacity: string,
  oil_grade: string,
  air_filter_price?: number;
  fuel_filter_price?: number;
  labor_price: number;
  travel_price: number;
}
export default function OilSelection({ carDetails, onNextStep, onBackStep }: OilSelectionProps) {
  const { t } = useTranslation();
  const [selectedOil, setSelectedOil] = useState<string | null>('HELIX');
  const [pricingDetails, setPricingDetails] = useState<PricingDetails | undefined >();
  const [loading, setLoading] = useState(false);
  


  useEffect(() => {
    const fetchPricing = async () => {
      try {
        setLoading(true);
        const response = await apiService.getPricing({
          id_brand: carDetails.id_brand,
          service_type: 'simple'
        });

        if (response.success) {
          setPricingDetails(response.data.prices);
        } else {
        }
      } catch (err) {
        console.error('Error fetching pricing:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPricing();
  }, [carDetails, t]);
  const handleNext = () => {
    if (selectedOil) {
      onNextStep({
        brand: selectedOil
      },
          pricingDetails);
    }
  };

  return (
    <div className="flex flex-col min-h-screen  bg-[#ededed]">
      <div className="flex flex-col items-center px-4 max-w-md mx-auto w-full">
                   <button
          onClick={onBackStep}
          className="self-start  relative top-12 mb-4 flex items-center text-blue-500"
          aria-label="Retour à l'étape précédente"
        >
          <ChevronLeft className="w-5 h-5 mr-1" />
          {t('common.back')}
        </button>

        <h1 className="text-[32px]  text-center mb-8 font-light">
          {t('oil.title')}
        </h1>

        <p className="text-center text-[16px]  mb-4 leading-relaxed max-w-full">
          {t('oil.description', { grade: pricingDetails?.oil_grade, model: carDetails.model })}
        </p>

        {loading ? (
            <div className="flex items-center justify-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-[#2196F3]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {t('common.loading')}
            </div>
          ) : (
        <>
           
        <div className="w-full grid grid-cols-1 gap-4 mb-6 " >
          {/* HELIX  */}
          
          <div className="flex flex-col items-center"  onClick={() => setSelectedOil('HELIX')}>
            <div className="w-42 h-42 ">
              <img
                src={`/oils/${pricingDetails?.oil_grade.toLowerCase()}.png`}
                alt={t('oil.motulAlt')}
                style={{width : '75%'}}
                className="mx-auto object-contain"
              />
            </div>
            <h3 className="text-xl mb-2 font-bold">HELIX - {pricingDetails?.oil_grade}</h3>
            <p className="text-sm text-gray-500 text-center mb-4 px-2">
              {t('oil.premiumChoice')}
            </p>
            <div className="flex items-center gap-2">
              <div className="flex items-center justify-center w-40 h-10 rounded-full border border-gray-300 bg-white shadow">
              {`${pricingDetails?.oil_price.HELIX}`} MAD
              </div>
              <button
               
                className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                  selectedOil === 'HELIX' 
                    ? 'border-[#2196F3] bg-[#2196F3]' 
                    : 'border-gray-300'
                }`}
                aria-label={t('oil.selectMotul')}
              >
                {selectedOil === 'HELIX' && (
                  <div className="w-3 h-3 rounded-full bg-white" />
                )}
              </button>
            </div>
          </div>

  
        </div>
       

        <button 
          className="w-[90%] mt-3 py-4 px-6 rounded-full bg-white text-[#2196F3]   border-[#2196F3] border-2  font-bold shadow-lg text-lg  hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleNext}
          disabled={!selectedOil}
        >
          {t('common.next')}
        </button>
        </>
         )}
      </div>
    </div>
  );
}
